"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReturnStatus = exports.PaymentType = exports.PaymentStatus = exports.PackageStatus = exports.ExportStatus = exports.DeliveryPartner = exports.ConfirmDeliveryStatus = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.replace-all.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerOrderForm = _interopRequireDefault(require("./CustomerOrderForm.vue"));
var _giftAway = require("@/api/gift-away");
var _ProductOrderForm = _interopRequireDefault(require("./ProductOrderForm.vue"));
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var _giveaway = require("@/types/giveaway");
var _shopeeOrder = require("@/api/shopeeOrder.api");
var _shopifyOrder = require("@/api/shopifyOrder.api");
var _customer = require("@/api/customer");
var GiveAwayModal = /*#__PURE__*/function (_Vue) {
  function GiveAwayModal() {
    var _this;
    (0, _classCallCheck2.default)(this, GiveAwayModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, GiveAwayModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "GiveawayType", _giveaway.GiveawayType);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      products: []
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "giveawayStatus", "");
    (0, _defineProperty2.default)(_this, "createdAt", 0);
    (0, _defineProperty2.default)(_this, "isLinkShopee", false);
    (0, _defineProperty2.default)(_this, "shopType", void 0);
    (0, _defineProperty2.default)(_this, "addCustomerDialogVisible", false);
    (0, _defineProperty2.default)(_this, "shopifyOrderId", null);
    (0, _defineProperty2.default)(_this, "customer", null);
    return _this;
  }
  (0, _inherits2.default)(GiveAwayModal, _Vue);
  return (0, _createClass2.default)(GiveAwayModal, [{
    key: "handleCreateCustomer",
    value: function handleCreateCustomer() {
      console.log("customer ne", this.customer);
      this.addCustomerDialogVisible = false;
      this.$refs.customerModal.handleCreateFromShopifyOrder(this.customer);
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$confirm("Confirm delete order", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 2:
              _context.prev = 2;
              this.loading = true;
              _context.next = 6;
              return _giftAway.giveAwayApi.delete(this.form.id);
            case 6:
              this.$emit("submit:ok");
              this.visible = false;
              this.$notify.success({
                title: "Delete order",
                message: "Successfully"
              });
            case 9:
              _context.prev = 9;
              this.loading = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var form, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$refs.customer.$refs.form.validate();
            case 3:
              _context2.next = 5;
              return this.$refs.product.$refs.form.validate();
            case 5:
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", this.$message.error("Fill correct all input"));
            case 10:
              if (!this.form.products.some(function (el) {
                return el.quantity > el.productQuantity;
              })) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return", this.$message.error("The quantity entered must be less than the quantity of lot number"));
            case 12:
              if (this.form.products.length) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", this.$message.error("Products least 1 item!"));
            case 14:
              form = (0, _objectSpread2.default)({}, this.form);
              delete form.products;
              data = {
                giveaway: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  createdAt: form.createdAt / 1000
                }),
                addressCityId: form.addressCityId,
                addressDistrictId: form.addressDistrictId,
                addressWardId: form.addressWardId,
                details: this.form.products.map(function (e) {
                  return {
                    quantity: e.quantity,
                    productId: e.id,
                    isPublished: e.isPublished,
                    lotNumber: e.lotNumber,
                    expired: e.expired,
                    dateOfManufacture: e.dateOfManufacture,
                    shopifyOrderDetailId: e.shopifyOrderDetailId,
                    shopeeOrderDetailId: e.shopeeOrderDetailId
                  };
                }),
                customerId: this.form.customerId,
                staffId: this.form.staffId,
                shopeeOrderId: this.form.shopeeOrderId,
                shopifyOrderId: this.form.shopifyOrderId
              };
              this.loading = true;
              _giftAway.giveAwayApi.create(data).then(function () {
                _this2.$notify.success({
                  title: "New gift",
                  message: "Successfully"
                });
                _this2.$emit("submit:ok");
                _this2.visible = false;
              }).finally(function () {
                return _this2.loading = false;
              });
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var form;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.prev = 1;
              _context3.next = 4;
              return this.$refs.customer.$refs.form.validate();
            case 4:
              _context3.next = 6;
              return this.$refs.product.$refs.form.validate();
            case 6:
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", this.$message.error("Fill correct all input"));
            case 11:
              if (this.form.products.length) {
                _context3.next = 13;
                break;
              }
              return _context3.abrupt("return", this.$message.error("Products least 1 item!"));
            case 13:
              this.loading = true;
              form = (0, _objectSpread2.default)({}, this.form);
              _context3.next = 17;
              return _giftAway.giveAwayApi.update(this.form.id, {
                giveaway: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  createdAt: form.createdAt / 1000
                }),
                addressCityId: this.form.addressCityId,
                addressDistrictId: this.form.addressDistrictId,
                addressWardId: this.form.addressWardId,
                customerId: this.form.customerId,
                staffId: this.form.staffId,
                shopeeOrderId: this.form.shopeeOrderId,
                shopifyOrderId: this.form.shopifyOrderId
              });
            case 17:
              _context3.next = 19;
              return this.updateDetail();
            case 19:
              _context3.next = 21;
              return this.updateDateCreated();
            case 21:
              this.visible = false;
              this.$notify({
                title: "Update order",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:ok");
            case 24:
              _context3.prev = 24;
              this.loading = false;
              return _context3.finish(24);
            case 27:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0,, 24, 27], [1, 8]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "updateDateCreated",
    value: function () {
      var _updateDateCreated = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if ((0, _lodash.isEqual)(this.form.createdAt, this.createdAt)) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return _giftAway.giveAwayApi.updateCreatedAt(this.form.id, {
                createdAt: this.form.createdAt / 1000
              });
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateDateCreated() {
        return _updateDateCreated.apply(this, arguments);
      }
      return updateDateCreated;
    }()
  }, {
    key: "updateDetail",
    value: function () {
      var _updateDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var i, e, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.form.products.length)) {
                _context5.next = 16;
                break;
              }
              e = this.form.products[i];
              data = {
                quantity: e.quantity,
                productId: e.id,
                isPublished: e.isPublished,
                lotNumber: e.lotNumber,
                expired: e.expired,
                dateOfManufacture: e.dateOfManufacture
              };
              if (e.detailId) {
                _context5.next = 9;
                break;
              }
              _context5.next = 7;
              return _giftAway.giveAwayApi.addDetail(this.form.id, {
                detail: data
              });
            case 7:
              _context5.next = 13;
              break;
            case 9:
              _context5.next = 11;
              return _giftAway.giveAwayApi.updateDetailQuantity(e.detailId, {
                quantity: e.quantity
              });
            case 11:
              _context5.next = 13;
              return _giftAway.giveAwayApi.updateDetail(e.detailId, {
                giveawayDetail: data
              });
            case 13:
              i++;
              _context5.next = 1;
              break;
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateDetail() {
        return _updateDetail.apply(this, arguments);
      }
      return updateDetail;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {
        products: [],
        addressDistrictId: null,
        addressWardId: null,
        addressCityId: null,
        createdAt: (0, _moment.default)().valueOf(),
        type: this.type
      };
    }
  }, {
    key: "fetchGiveAway",
    value: function () {
      var _fetchGiveAway = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var _res$data$shopeeOrder, _res$data$shopifyOrde;
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _giftAway.giveAwayApi.findOne(this.form.id);
            case 2:
              res = _context6.sent;
              debugger;
              this.createdAt = res.data.createdAt * 1000;
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
                createdAt: res.data.createdAt * 1000,
                products: res.data.giveawayDetails.map(function (e) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                    id: e.product.id,
                    productGalleries: e.product.productGalleries,
                    name: e.product.name,
                    detailId: e.id
                    // productQuantity: e.quantity,
                  });
                }),
                addressCityId: res.data.addressCity && res.data.addressCity.id,
                addressDistrictId: res.data.addressDistrict && res.data.addressDistrict.id,
                addressWardId: res.data.addressWard && res.data.addressWard.id,
                customerId: res.data.customer && res.data.customer.id,
                staffId: res.data.staff && res.data.staff.id,
                shopeeOrderId: (_res$data$shopeeOrder = res.data.shopeeOrder) === null || _res$data$shopeeOrder === void 0 ? void 0 : _res$data$shopeeOrder.id,
                shopifyOrderId: (_res$data$shopifyOrde = res.data.shopifyOrder) === null || _res$data$shopifyOrde === void 0 ? void 0 : _res$data$shopifyOrde.id
              });
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchGiveAway() {
        return _fetchGiveAway.apply(this, arguments);
      }
      return fetchGiveAway;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      this.fetchGiveAway();
      this.visible = true;
      this.status = "update";
      this.giveawayStatus = data.status;
    }
    // Xu ly lay chi tiet don shopee roi map với sản phẩm hiện có để tạo đơn
  }, {
    key: "fetchDetailShopeeOrder",
    value: function () {
      var _fetchDetailShopeeOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7(id) {
        var res, products, shopeeOrderDetails, index, _loop, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _shopeeOrder.shopeeOrderApi.findOne(id);
            case 2:
              res = _context8.sent;
              products = [];
              shopeeOrderDetails = res.data.shopeeOrderDetails.filter(function (e) {
                return !e.mainItem;
              });
              index = 0;
              _loop = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop(i) {
                var _element$shopeeProduc;
                var element;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      element = shopeeOrderDetails[i]; // if (element.orderDetails.length !== 0) continue;
                      if (((_element$shopeeProduc = element.shopeeProduct) === null || _element$shopeeProduc === void 0 ? void 0 : _element$shopeeProduc.products2.length) != 0) {
                        element.shopeeProduct.products2.forEach(function (product) {
                          products.push({
                            product: product,
                            id: product.id,
                            productGalleries: product.productGalleries,
                            name: product.name,
                            quantity: element.quantity,
                            totalPrice: 0,
                            commissionAmount: 0,
                            maxQuantity: null,
                            indexProduct: i,
                            shopeeOrderDetailId: element.id
                          });
                          index++;
                        });
                      }
                      // if (element.shopeeProduct?.product) {
                      //   const product = element.shopeeProduct.product;
                      //   products.push({
                      //     product: product,
                      //     id: product.id,
                      //     productGalleries: product.productGalleries,
                      //     name: product.name,
                      //     quantity: element.quantity,
                      //     totalPrice: 0,
                      //     commissionAmount: 0,
                      //     maxQuantity: null,
                      //     indexProduct: i,
                      //     shopeeOrderDetailId: element.id,
                      //   });
                      // }
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 8:
              if (!(i < shopeeOrderDetails.length)) {
                _context8.next = 13;
                break;
              }
              return _context8.delegateYield(_loop(i), "t0", 10);
            case 10:
              i++;
              _context8.next = 8;
              break;
            case 13:
              this.form = {
                products: products,
                shopeeOrderId: id,
                addressDistrictId: null,
                addressWardId: null,
                addressCityId: null,
                createdAt: (0, _moment.default)().valueOf(),
                type: this.type
              };
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this);
      }));
      function fetchDetailShopeeOrder(_x) {
        return _fetchDetailShopeeOrder.apply(this, arguments);
      }
      return fetchDetailShopeeOrder;
    }()
  }, {
    key: "handleFetchShopifyOrderAfterCreateCustomer",
    value: function () {
      var _handleFetchShopifyOrderAfterCreateCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.$refs.customer.fetchCustomers();
            case 2:
              _context9.next = 4;
              return this.fetchDetailShopifyOrder(this.shopifyOrderId);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this);
      }));
      function handleFetchShopifyOrderAfterCreateCustomer() {
        return _handleFetchShopifyOrderAfterCreateCustomer.apply(this, arguments);
      }
      return handleFetchShopifyOrderAfterCreateCustomer;
    }() // Xu ly lay chi tiet don shopify roi map với sản phẩm hiện có để tạo đơn
  }, {
    key: "fetchDetailShopifyOrder",
    value: function () {
      var _fetchDetailShopifyOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9(id) {
        var _res$data$phone;
        var res, products, shopifyOrderDetails, index, _loop2, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.shopifyOrderId = id;
              _context11.next = 3;
              return _shopifyOrder.shopifyOrderApi.findOne(id);
            case 3:
              res = _context11.sent;
              products = [];
              this.customer = {
                email: res.data.email == "No email provided" ? null : res.data.email,
                name: res.data.customerName,
                phone: res.data.phone == "No phone number" ? null : (_res$data$phone = res.data.phone) === null || _res$data$phone === void 0 ? void 0 : _res$data$phone.replace("+84", "0").replaceAll(" ", ""),
                address: res.data.shippingAddress
              };
              shopifyOrderDetails = res.data.shopifyOrderDetails;
              index = 0; //* Dùng check logic chọn lot number cho sản phẩm
              _loop2 = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop2() {
                var _element$shopifyProdu;
                var element;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop2$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      element = shopifyOrderDetails[i];
                      if (!(element.orderDetails.length !== 0)) {
                        _context10.next = 3;
                        break;
                      }
                      return _context10.abrupt("return", 1);
                    case 3:
                      if (((_element$shopifyProdu = element.shopifyProduct) === null || _element$shopifyProdu === void 0 ? void 0 : _element$shopifyProdu.products2.length) != 0) {
                        element.shopifyProduct.products2.forEach(function (product) {
                          products.push({
                            product: product,
                            id: product.id,
                            productGalleries: product.productGalleries,
                            name: product.name,
                            quantity: element.quantity,
                            totalPrice: 0,
                            commissionAmount: 0,
                            maxQuantity: null,
                            indexProduct: index,
                            shopifyOrderDetailId: element.id
                          });
                          index++;
                        });
                      }
                      // if (element.shopifyProduct?.product) {
                      //   const product = element.shopifyProduct.product;
                      //   products.push({
                      //     product: product,
                      //     id: product.id,
                      //     productGalleries: product.productGalleries,
                      //     name: product.name,
                      //     quantity: element.quantity,
                      //     totalPrice: 0,
                      //     commissionAmount: 0,
                      //     maxQuantity: null,
                      //     indexProduct: i,
                      //     shopifyOrderDetailId: element.id,
                      //   });
                      // }
                    case 4:
                    case "end":
                      return _context10.stop();
                  }
                }, _loop2);
              });
              i = 0;
            case 10:
              if (!(i < shopifyOrderDetails.length)) {
                _context11.next = 17;
                break;
              }
              return _context11.delegateYield(_loop2(), "t0", 12);
            case 12:
              if (!_context11.t0) {
                _context11.next = 14;
                break;
              }
              return _context11.abrupt("continue", 14);
            case 14:
              i++;
              _context11.next = 10;
              break;
            case 17:
              this.form = {
                products: products,
                shopifyOrderId: id,
                addressDistrictId: null,
                addressWardId: null,
                addressCityId: null,
                createdAt: (0, _moment.default)().valueOf(),
                type: this.type
              };
              // this.handleCheckExistCustomerByEmail(res.data);
              this.handleCheckExistCustomerByEmailAndPhone();
            case 19:
            case "end":
              return _context11.stop();
          }
        }, _callee9, this);
      }));
      function fetchDetailShopifyOrder(_x2) {
        return _fetchDetailShopifyOrder.apply(this, arguments);
      }
      return fetchDetailShopifyOrder;
    }()
  }, {
    key: "handleCheckExistCustomerByEmailAndPhone",
    value: function () {
      var _handleCheckExistCustomerByEmailAndPhone = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10() {
        var phone, email, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              phone = this.customer.phone;
              email = this.customer.email;
              if (!(phone || email)) {
                _context12.next = 7;
                break;
              }
              _context12.next = 5;
              return _customer.customerApi.findOneByEmailAndPhone({
                email: email,
                phone: phone
              });
            case 5:
              res = _context12.sent;
              if ((0, _lodash.isEmpty)(res.data)) {
                this.addCustomerDialogVisible = true;
              } else {
                this.$set(this.form, "customerId", res.data.id);
              }
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee10, this);
      }));
      function handleCheckExistCustomerByEmailAndPhone() {
        return _handleCheckExistCustomerByEmailAndPhone.apply(this, arguments);
      }
      return handleCheckExistCustomerByEmailAndPhone;
    }()
  }, {
    key: "handleLink",
    value: function handleLink(data, type) {
      this.isLinkShopee = true;
      console.log({
        type: type
      });
      if (type === "shopee") {
        this.fetchDetailShopeeOrder(data.id);
      } else {
        this.fetchDetailShopifyOrder(data.id);
      }
      // this.fetchDetailShopeeOrder(data.id);
      this.giveawayStatus = "";
      this.visible = true;
      this.status = "create";
      this.shopType = type;
    }
  }, {
    key: "handleCheckExistCustomerByEmail",
    value: function () {
      var _handleCheckExistCustomerByEmail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11(orderShopify) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(!orderShopify.email || orderShopify.email == "No email provided")) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              _context13.next = 4;
              return _customer.customerApi.findOneByEmail({
                email: orderShopify.email
              });
            case 4:
              res = _context13.sent;
              if ((0, _lodash.isEmpty)(res.data)) {
                this.addCustomerDialogVisible = true;
              } else {
                this.$set(this.form, "customerId", res.data.id);
              }
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee11, this);
      }));
      function handleCheckExistCustomerByEmail(_x3) {
        return _handleCheckExistCustomerByEmail.apply(this, arguments);
      }
      return handleCheckExistCustomerByEmail;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], GiveAwayModal.prototype, "type", void 0);
GiveAwayModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductOrderForm: _ProductOrderForm.default,
    CustomerOrderForm: _CustomerOrderForm.default,
    CustomerDialog: function CustomerDialog() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/customer/components/CustomerDialog.vue"));
      });
    }
  }
})], GiveAwayModal);
var _default = exports.default = GiveAwayModal;
var PaymentType;
(function (PaymentType) {
  PaymentType["Cash"] = "CASH";
  PaymentType["COD"] = "COD";
  PaymentType["Transfer"] = "TRANSFER";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var DeliveryPartner;
(function (DeliveryPartner) {
  DeliveryPartner["GHTK"] = "GHTK";
  DeliveryPartner["Grab"] = "GRAB";
  DeliveryPartner["PostOffice"] = "POST_OFFICE";
})(DeliveryPartner || (exports.DeliveryPartner = DeliveryPartner = {}));
var PackageStatus;
(function (PackageStatus) {
  PackageStatus["Pending"] = "PENDING";
  PackageStatus["Complete"] = "COMPLETE";
})(PackageStatus || (exports.PackageStatus = PackageStatus = {}));
var ExportStatus;
(function (ExportStatus) {
  ExportStatus["Pending"] = "PENDING";
  ExportStatus["Complete"] = "COMPLETE";
})(ExportStatus || (exports.ExportStatus = ExportStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
  PaymentStatus["Pending"] = "PENDING";
  PaymentStatus["Complete"] = "COMPLETE";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var ReturnStatus;
(function (ReturnStatus) {
  ReturnStatus["Pending"] = "PENDING";
  ReturnStatus["Complete"] = "COMPLETE";
})(ReturnStatus || (exports.ReturnStatus = ReturnStatus = {}));
var ConfirmDeliveryStatus;
(function (ConfirmDeliveryStatus) {
  ConfirmDeliveryStatus["Pending"] = "PENDING";
  ConfirmDeliveryStatus["Complete"] = "COMPLETE";
})(ConfirmDeliveryStatus || (exports.ConfirmDeliveryStatus = ConfirmDeliveryStatus = {}));